import type { VisualPromptDefinition } from '@/types/visualPrompts/visualPrompt.types';

export const sortPromptsByFeatured = (
  prompts: VisualPromptDefinition[],
): VisualPromptDefinition[] =>
  [...prompts].sort((a, b) => {
    const aFeatured = a.isFeatured ? 0 : 1;
    const bFeatured = b.isFeatured ? 0 : 1;
    if (aFeatured !== bFeatured) {
      return aFeatured - bFeatured;
    }
    return a.title.localeCompare(b.title);
  });
